import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation,Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Helmet } from "react-helmet-async";
import { query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy ,updateDoc } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import Swal from "sweetalert2";
import { useAuth } from '../../context/AuthContext';

const HomePendidik = () => {
  const [data, setData] = useState([]);
  const [informasiAkun, setInformasiAkun] = useState(null);
  const [ujianData, setUjianData] = useState([]);
    const { user, loading, logout } = useAuth();
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMenu = async () => {
      const authToken = localStorage.getItem('authToken');
      console.log(authToken)
      if (!authToken) {

        //navigate('/login');
        return;
      }

      try {
        // Decode token untuk mendapatkan informasi akun
        const decoded = jwtDecode(authToken);
        setInformasiAkun(decoded);

        if (!decoded.akses) {
          navigate('/daftar/identifikasiakses');
          return;
        }

        // Fetch data menu dari server
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/users/getDashboardData`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error("className= menu");
        }

        const data = await response.json();
        setData(data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMenu();
  }, [navigate]);

 const fetchUjian = async () => {
  console.log(user)
  try {
    if (!user?.npsn || !user?.uid) {
      console.error("Data dalam token tidak valid.");
      return;
    }

    const q = query(
      collection(db, "jadwal"),
      where("npsn", "==", user.npsn),
      where("id_pengawas", "==", user.uid)   // ✔ perbaiki di sini
    );

    const ujianSnap = await getDocs(q);

    const ujianList = ujianSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log(ujianList)

    return ujianList;

  } catch (error) {
    console.error("Error fetching data:", error);
  }
};


  useEffect(() => {
    const getData = async () => {
      const data = await fetchUjian();
      console.log("Data ujian berhasil diambil:", data);

      if (data) {
        setUjianData(data);
      }
    };
    getData();
  }, []);

  const dummyUjian = {
    'TES123': {
      nama: 'Ujian Matematika',
      waktu: '10:00 - 12:00',
      tanggal: '2025-04-10',
      ruangan: 'Ruang 1',
    },
    'TES456': {
      nama: 'Ujian Bahasa Inggris',
      waktu: '13:00 - 15:00',
      tanggal: '2025-04-11',
      ruangan: 'Ruang 2',
    }
  };
  

    const [show, setShow] = useState(false);
    const [kode, setKode] = useState('');
    const [ujian, setUjian] = useState(null);
    const [notFound, setNotFound] = useState(false);
  
    const handleClose = () => {
      setShow(false);
      setKode('');
      setUjian(null);
      setNotFound(false);
    };
  
    const handleShow = () => setShow(true);
  
    const handleCari = async () => {
      const authToken = localStorage.getItem("authToken");
  
      if (!authToken) {
        console.error("Token tidak ditemukan, harap login kembali.");
        return;
      }
  
      const decoded = jwtDecode(authToken);
        setNotFound(false);
        const q = query(
          collection(db, "jadwal"),
          where("npsn", "==", decoded.npsn),
          where("id_pengawas", "==", decoded.wa_number),
          where("id","==",kode.trim().toUpperCase())
        );
    
        const ujianSnap = await getDocs(q);
        const ujianList = ujianSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const found = dummyUjian[kode.trim().toUpperCase()];
        if (found) {
        setUjian(ujianList);



      } else {
        setUjian(null);
        setNotFound(true);
      }
    };


     const inputPIN = async () => {
      let pinValue = "";
    
      await Swal.fire({
        title: "Masukkan Kode Tes",
        html: `
          <div class="input-group mb-2">
            <input type="text" class="form-control" id="kodeTesInput" placeholder="KODE TES">
            <div class="input-group-prepend">
              <div id="btnCariJadwal" class="input-group-text btn btn-danger">
                <i style="font-size:20px" class="ti ti-send"></i>
              </div>
            </div>
          </div>
    
          <div id="hasilJadwal" class="mt-2" style="min-height:40px; font-size:14px;"></div>
        `,
        showCancelButton: true,
        confirmButtonText: "OK",
    
        didOpen: () => {
          const input = Swal.getPopup().querySelector("#kodeTesInput");
          const btnCari = Swal.getPopup().querySelector("#btnCariJadwal");
          const hasil = Swal.getPopup().querySelector("#hasilJadwal");
    
          btnCari.addEventListener("click", async () => {
            pinValue = input.value.trim();
            hasil.innerHTML = "Mencari jadwal...";
    
            const q = query(collection(db, "jadwal"), where("kode", "==", pinValue));
            const snapshot = await getDocs(q);
    
            if (snapshot.empty) {
              hasil.innerHTML = `<span class="text-danger">Kode tidak ditemukan</span>`;
              return;
            }
    
            const data = snapshot.docs[0].data();
            const listMpl = data?.data ?? [];

navigate("/pendidik/halamantes", {
          state: {
            kode: data.kode,
            id: pinValue,
            nama_mapel: data.nama_mapel,
          },
        });
    Swal.close(); // 🔥 Tutup popup
          
          });
        },
    
        preConfirm: () => pinValue,
      });
    };



  return (
    <>
      <Helmet>
        <title>Dashbard Griya Vidya</title>
      </Helmet>
      <div>
        
            <div className="row">
              {data?.map((item, index) =>
                item.type === "Card" ? (
                  item?.data?.map((subItem, subIndex) => (
                    <div className="col-xl-3 col-md-6" key={subIndex}>
                      <div className="card">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h5 className="m-b-20">{subItem.title}</h5>
                              <h3>{subItem.data}</h3>

                            </div>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : null
              )}
              <div className="col-xl-12 col-md-12 p-2">

              
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header d-flex align-items-center justify-content-between py-3">
                    <h5 className="mb-0">Riwayat Ujian</h5>
                    <button className="btn btn-sm btn-primary" onClick={inputPIN}>MULAI UJIAN</button>
                  </div>
                  <div className="card-body">
                  <ul className='list-group list-group-flush'>

                  {ujianData?.map((item, index) => (
                    <li key={index} className="list-group-item px-0">
                      <div className="d-flex align-items-center">
                      
                        <div className="flex-grow-1 ms-3">
                          <div className="row g-1">
                      
                         <Link 
  to="/pendidik/halamantes"
  state={{
    kode: item?.kode,
    id: item?.kode,
    nama_mapel: data.nama_mapel,
  }}
  className="text-decoration-none"
>
  <div>
    <h5 className="mb-0">{item.ruang} - {item?.kode}</h5>
     {item.status}

    <p className="text-muted mb-0">
      <small>
        {item.waktu_mulai?.seconds
          ? new Date(item.waktu_mulai.seconds * 1000).toLocaleString()
          : "Tanggal tidak tersedia"}
      </small>
    </p>
  </div>
</Link>

                            <div className="col-6">
                              <h6 className="mb-1">{item?.peserta?.length} / {item?.daftar_peserta?.length}</h6>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                      
                    </ul>
                  </div>
                </div>
              </div>

            </div> 
          </div>
     

      {/* <Button variant="primary" onClick={handleShow}>
        Masukkan Kode Tes
      </Button> */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cari Ujian</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Kode Tes</Form.Label>
            <Form.Control
              type="text"
              placeholder="Masukkan kode tes"
              value={kode}
              onChange={(e) => setKode(e.target.value)}
            />
          </Form.Group>

          <Button className="mt-3" onClick={handleCari}>
            Cari
          </Button>

          {notFound && (
            <Alert variant="danger" className="mt-3">
              Kode tidak terdaftar.
            </Alert>
          )}

          {ujian && (
            <div className="mt-3">
              <h5>Detail Ujian:</h5>
              <ul>
                <li><strong>Nama:</strong> {ujian.nama}</li>
                <li><strong>Tanggal:</strong> {ujian.tanggal}</li>
                <li><strong>Waktu:</strong> {ujian.waktu}</li>
                <li><strong>Ruangan:</strong> {ujian.ruangan}</li>
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );



};

export default HomePendidik;
